<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-card-title-custom">
      {{'enterprise_user_management.screen_name' | translate}}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'enterprise_user_management.ttl_search' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form #f="ngForm" (ngSubmit)="searchUser(0, paginate.pageSize)" class="pb-3">
          <div class="row">
            <div class="col-lg-4">
              <!-- Auto complete field -->
              <mat-form-field class="mat-full-width">
                <input type="text" (focusout)="user.enterpriseName = user.enterpriseName.trim()" #focusInput matInput
                       [placeholder]="'enterprise_user_management.lbl_branch_enterprise' | translate"
                       [(ngModel)]="user.enterpriseName" name="enterpriseName" maxlength="200" autocomplete="off" />
                <button mat-button *ngIf="user.enterpriseName" type="button" matSuffix mat-icon-button aria-label="Clear"
                        (click)="user.enterpriseName=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div class="col-lg-4">
              <!-- Auto complete field -->
              <mat-form-field class="mat-full-width">
                <input type="text" (focusout)="user.fullName = user.fullName.trim()" #focusInput matInput
                       [placeholder]="'enterprise_user_management.lbl_full_name' | translate"
                       [(ngModel)]="user.fullName" name="fullName" maxlength="200" autocomplete="off" />
                <button mat-button *ngIf="user.fullName" type="button" matSuffix mat-icon-button aria-label="Clear"
                        (click)="user.fullName=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div class="col-lg-4">
              <mat-form-field class="mat-full-width">
                <input type="text" (focusout)="user.keyword = user.keyword.trim()" matInput
                       [placeholder]="'enterprise_user_management.lbl_email' | translate" name="text" maxlength="200"
                       [(ngModel)]="user.keyword" autocomplete="off">
                <button mat-button *ngIf="user.keyword" type="button" matSuffix mat-icon-button aria-label="Clear"
                        (click)="user.keyword=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div class="col-lg-4">
              <mat-form-field class="mat-full-width">
                <mat-label>{{'enterprise_user_management.cbx_status.lbl_status' | translate}}</mat-label>
                <mat-select #statusSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                            (focus)="commonService.openComboBox(checkFocus, statusSelect)" id="active" name="active"
                            [(ngModel)]="user.isActive" (ngModelChange)="searchUser(0, paginate.pageSize)">
                  <mat-option value="null" selected (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'enterprise_user_management.cbx_status.cbx_status_select_all' | translate}}</mat-option>
                  <mat-option value="true" (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'enterprise_user_management.cbx_status.cbx_status_active' | translate}}
                  </mat-option>
                  <mat-option value="false" (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'enterprise_user_management.cbx_status.cbx_status_inactive' | translate}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

          </div>
          <div class="row">
            <div class="col-lg-12 d-flex justify-content-center">
              <button mat-stroked-button color="primary" type="submit" (click)="onClickBtnFilter()" [disabled]="isTableLoading">
                <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                {{'enterprise_user_management.buttons.search' | translate}}
              </button>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-panel-title class="mat-panel-title mt-3 d-flex justify-content-between align-items-center">
          <div class="col-4 pl-0 pr-075">
            <span>{{'enterprise_user_management.list_user' | translate}} ({{paginate.totalRow}})</span>
          </div>
          <div class="col-8 mt-3 pr-075">
            <button class="pull-right mb-2 ml-3" mat-stroked-button color="primary" (click)="onImportFile()" [disabled]="commonService.getIsLockedEnterprise()">
              <mat-icon class="mr-0">add_circle</mat-icon> {{'enterprise_customer_management.add_from_file' | translate}}
            </button>
            <button class="float-right" mat-stroked-button color="primary" (click)="openDialogAdd()" [disabled]="commonService.getIsLockedEnterprise()">
              <mat-icon class="mr-0">add_circle</mat-icon> {{'enterprise_user_management.buttons.add' | translate}}
            </button>
          </div>
        </mat-panel-title>
        <div class="mat-table-container">
          <mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="stt">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{'enterprise_user_management.table_headers.no' | translate}}</mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{ paginate.no[dataSource.filteredData.indexOf(element)] }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell no-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="enterprise">
              <mat-header-cell *matHeaderCellDef [ngClass]="'customWidthClass'" class="mat-cell-non-boder-right-bottom"
                               style="width: 27%;">
                {{ "enterprise_user_management.table_headers.enterprise" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" [ngClass]="'customWidthClass'" class="mat-cell-non-boder-right-bottom"
                        style="width: 27%;" matTooltip="{{ element.enterpriseName }}">
                <span class="fix-width fw-100">{{ element.enterpriseName }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="width: 27%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom" style="max-width: 18%;">
                {{ "enterprise_user_management.table_headers.name" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.fullName }}"
                        class="mat-cell-non-boder-right-bottom" style="max-width: 18%;">
                <span class="fix-width">{{ element.fullName }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 18%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="userName">
              <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom" style="max-width: 18%;">
                {{ "enterprise_user_management.table_headers.username" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.userName }}"
                        class="mat-cell-non-boder-right-bottom" style="max-width: 18%;">
                <span class="fix-width">{{ element.userName }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 18%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="email">
              <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom" style="max-width: 25%;">
                {{ "enterprise_user_management.table_headers.email" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.email }}"
                        class="mat-cell-non-boder-right-bottom" style="max-width: 25%;">
                <span class="fix-width">{{ element.email }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 25%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="phone">
              <mat-header-cell *matHeaderCellDef style="max-width: 12%;">
                {{ "enterprise_user_management.table_headers.phone" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="number-cell-center"
                        style="max-width: 12%;">
                <span class="fix-width">{{ element.phone }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 12%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef
                               class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom">
                {{ "enterprise_user_management.table_headers.status" | translate }}
              </mat-header-cell>
              <!-- [matTooltip]="element.isActive? ('enterprise_group_user_management.tooltips.icon_status_active' | translate) + '&#13;'+ ('enterprise_group_user_management.tooltips.click_change_status' | translate)
                : ('enterprise_group_user_management.tooltips.icon_status_inactive' | translate) + '&#13;'+ ('enterprise_group_user_management.tooltips.click_change_status' | translate)" -->
              <mat-cell *matCellDef="let element"
                        class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom"
                        matTooltipClass="matTooltipBreakLine"
                        [matTooltip]="(element.isActive && getPermisionSME)? ('system_document_template.tooltips.icon_status_active' | translate) :
                (!element.isActive && getPermisionSME)? ('system_document_template.tooltips.icon_status_inactive' | translate) :
                (element.isActive) ? ('enterprise_user_management.tooltips.icon_status_active' | translate) : ('enterprise_user_management.tooltips.icon_status_inactive' | translate)">
                <button mat-icon-button (click)="onChangeStatus(element.id, element.fullName, element.isActive)" [disabled]="commonService.getIsLockedEnterprise() || getPermisionSME">
                  <mat-icon *ngIf="element.isActive">lock_open</mat-icon>
                  <mat-icon *ngIf="!element.isActive">lock</mat-icon>
                </button>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell status-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-bottom"
                               style="max-width: 100px;">
                {{'headertable.action' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-bottom"
                        style="max-width: 100px;">
                <button mat-icon-button (click)="openDialogEdit(element.id)" [disabled]="commonService.getIsLockedEnterprise()">
                  <mat-icon matTooltip="{{'enterprise_user_management.buttons.edit' | translate}}">edit
                  </mat-icon>
                </button>
                <ng-container *ngIf="!getPermisionSME">
                  <button mat-icon-button *ngIf="element.userType == 2; else admin " (click)="openDialogAutho(element.id)" [disabled]="commonService.getIsLockedEnterprise()">
                    <mat-icon matTooltip="{{'enterprise_user_management.buttons.auth' | translate}}">
                      supervisor_account</mat-icon>
                  </button></ng-container>
                <ng-container *ngIf="!isFromSSO" >
                  <button mat-icon-button *ngIf="!isFromSSO" (click)="delete(element.id,element.userName,element.fullName)">
                    <i class="fa fa-trash" aria-hidden="true" [ngClass]="{'disabled-locked': commonService.getIsLockedEnterprise()}"
                       matTooltip="{{'button.delete' | translate}}"></i>
                  </button></ng-container>
                <ng-template #admin>
                  <button mat-icon-button disabled >
                    <mat-icon matTooltip="{{'enterprise_user_management.buttons.un_auth' | translate}}">
                      account_circle</mat-icon>
                  </button>
                </ng-template>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 100px;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            <!-- hang skeleton trong bang: mat-footer-row render doc lap voi data nen ton tai
                 ca khi bang chua co du lieu; moi cot co mat-footer-cell rieng theo dung cot;
                 an/hien qua class theo isTableLoading -->
            <mat-footer-row *matFooterRowDef="displayedColumns"
                            class="table-skeleton-row"
                            [class.table-skeleton-hidden]="!isTableLoading"></mat-footer-row>
          </mat-table>
        </div>
        <!-- Pagination -->
        <app-pagination [(paginate)]="paginate" (pageChange)="searchUser($event.page, $event.pageSize)"
                        [isShowNoRecord]="!isTableLoading">
        </app-pagination>
        <!-- /Pagination -->
      </mat-expansion-panel>
    </mat-accordion>

  </mat-card-content>
</mat-card>
